import React from 'react'

const RoundedDownIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="5.5" transform="matrix(1.19249e-08 1 1 -1.19249e-08 0 0)" fill="#3249D7" stroke="#3249D7"/>
    <path d="M8.40473 5.29981L7.97433 4.875L6.07736 6.77197L4.18039 4.875L3.75 5.29981L6.07736 7.62717L8.40473 5.29981Z" fill="white"/>
    </svg>
    
    
  )
}

export default RoundedDownIcon
